import Page from "webPage/Page";
import StickySection from "util/StickySection";

import {handleScrollingSection} from "util/scrolling-section";

Page.register('page-template-add-products', () => {
    $('body').on('click', '.js-open-product-dropdown', function() {
        if ($(this).closest(".dropdown").hasClass("dropdown--active")) {
            $(this).closest(".dropdown").toggleClass("dropdown--active");
        } else {
            $(".dropdown").removeClass("dropdown--active");
            $(this).closest(".dropdown").addClass("dropdown--active");
        }
    }).on('click', '.js-close-product-dropdown', function() {
        if ($(this).closest(".dropdown").hasClass("dropdown--active")) {
            $(this).closest(".dropdown").toggleClass("dropdown--active");
        }
    });

    if ($('.measurement').length > 1) {
        new StickySection($('.js-sticky-section'), 760);
    }

    handleScrollingSection($(".js-rating-track-wrap"), 0, 1199);
});
